import { getAPIURL } from "./config";

const readErrorMessage = async (response, fallback) => {
  const errorText = await response.text();
  if (response.status === 422) {
    try {
      const err = JSON.parse(errorText);
      const details = Array.isArray(err.detail)
        ? err.detail.map((item) => item.msg || JSON.stringify(item)).join("; ")
        : err.detail;
      if (details) return `Ошибка валидации: ${details}`;
    } catch {
      if (errorText) return `${fallback}. ${errorText}`;
    }
  }
  return errorText ? `${fallback}. ${errorText}` : fallback;
};

/**
 * Журнал операций, слой source из 1C Oper.
 * GET /finance/journal
 * Без дат бэкенд отдаёт последние 90 дней.
 * @param {{ dateFrom?: string, dateTo?: string, account?: string, organization?: string, q?: string, limit?: number, offset?: number, signal?: AbortSignal }} params
 * dateFrom / dateTo — YYYY-MM-DD
 */
export const getFinanceJournal = async ({
  dateFrom,
  dateTo,
  account,
  organization,
  q,
  limit = 50,
  offset = 0,
  signal,
} = {}) => {
  const params = new URLSearchParams();
  if (dateFrom) params.set("date_from", dateFrom);
  if (dateTo) params.set("date_to", dateTo);
  if (account) params.set("account", account);
  if (organization) params.set("organization", organization);
  if (q) params.set("q", q);
  params.set("limit", String(limit));
  params.set("offset", String(offset));

  const response = await fetch(`${getAPIURL()}finance/journal?${params}`, {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "include",
    signal,
  });

  if (!response.ok) {
    const fallback = `Ошибка загрузки журнала операций: ${response.status} ${response.statusText}`;
    throw new Error(await readErrorMessage(response, fallback));
  }

  return response.json();
};
